<mat-dialog-actions>
  <div class="dialog-close">
    <i class="fas fa-times" (click)="onDialogCloseClick()"></i>
  </div>
  <div mat-dialog-title>Selected Image</div>
</mat-dialog-actions>
<mat-dialog-content class="image-container">
  <img [src]="data.imgSrc" alt="Selected Image" class="dialog-image" />
</mat-dialog-content>
